import { observer } from "mobx-react";
import React, { FC, PropsWithChildren } from "react";

interface Props extends PropsWithChildren{
    shadow?: boolean
    id?: string
    midScreen?: boolean
}

const PageBodyAlt: FC<Props> = (props) => {

    const { shadow = true, id = "", midScreen } = props
    let style: React.CSSProperties = { position: "fixed", left: "50%", top: "50%", transform: "translate(-50%, -50%)" }
    return (
        <div style={style} id={id}>
            {props.children}
        </div>
    )
}
export default PageBodyAlt
